import React, { useEffect, useState } from 'react';
import { CardHeader, Row } from 'reactstrap';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Container } from 'reactstrap';
import { ITable } from '../iTable/ITable';
import { getShipmentsHouses } from '../../../../store/actions';

const IshowHouses = ({ GUID, Number }: any) => {
    const dispatch = useDispatch();
    const valuesSizePagination = [10, 20, 30, 40, 50, 100];
    const { listHouses, milestoneConfig } = useSelector((state: any) => state.shipments);
    const [pagination, setPagination] = useState<{
        sizePerPage: number;
        page: number;
    }>({
        sizePerPage: 50,
        page: 1,
    });
    useEffect(() => {
        dispatch(getShipmentsHouses({ GUID }));
    }, [dispatch, pagination]);
    const handlePaginationChange = (newState: any) => {
        setPagination(newState);
    };
    const onPopUpState = () => {};
    const handleActionOnRowClick = (row: any) => {};
    
    return (
        <React.Fragment>
            <Container>
                <CardHeader className="cardHeader">
                    <h2 style={{ color: 'white' }}>Shipment Houses for Master: {Number}</h2>
                </CardHeader>
                <Container fluid>
                    <Row>
                        <Row>
                            <ITable
                                remote={false}
                                valuesSizePagination={valuesSizePagination}
                                handlerPaginationState={handlePaginationChange}
                                data={listHouses}
                                fields={milestoneConfig}
                                tableColumns={milestoneConfig}
                                disablePageTitle={true}
                                headerColorT="bg-primary text-white"
                                actionOnRowClick={handleActionOnRowClick}
                                handlePopUpState={onPopUpState}
                                groupName="ShipmentsDataViewList"
                            />
                        </Row>
                    </Row>
                </Container>
            </Container>
        </React.Fragment>
    );
};
IshowHouses.propTypes = {
    GUID: PropTypes.string.isRequired,
    Number: PropTypes.string.isRequired,
};
export default IshowHouses;
